import type { Project } from './types';

export const projects: Project[] = [
  {
    id: 'ai-website-checker',
    slug: 'ai-website-checker',
    title: 'AI Website Checker',
    titleDe: 'AI Website Checker',
    date: '2026-02-07',
    author: 'Stefan Artmann',
    summary: 'Scan your website for 2026-ready visibility across Search Engines (SEO), Answer Engines (AEO), and Generative Engines (GEO). Get a clear score, prioritized fixes, and a downloadable PDF report you can act on immediately.',
    summaryDe: 'Prüfe deine Website auf 2026-Sichtbarkeit für Suchmaschinen (SEO), Answer Engines (AEO) und Generative Engines (GEO). Du erhältst einen Score, priorisierte Fixes und einen PDF-Report zum direkten Umsetzen.',
    coverImage: '/assets/images/ai-website-checker-tool-1770431462466.jpg',
    tags: ['SEO', 'AEO', 'GEO', 'AI Visibility', 'PDF Report'],
    tagsDe: ['SEO', 'AEO', 'GEO', 'KI-Sichtbarkeit', 'PDF-Report'],
    category: 'Tools',
    categoryDe: 'Tools',
    ctaLabel: 'Open tool →',
    ctaLabelDe: 'Tool öffnen →',
    intro: [
      {
        type: 'p',
        text: 'The AI Website Checker is a comprehensive analysis tool designed to evaluate your website\'s visibility across the modern agentic AI and classic search landscape. In 2026, being found online means more than just ranking on Google. It means being discoverable by AI-powered Answer Engines and Generative Search Systems.',
      },
    ],
    introDe: [
      {
        type: 'p',
        text: 'Der AI Website Checker ist ein umfassendes Analyse-Tool zur Bewertung der Sichtbarkeit deiner Website in der modernen Suchlandschaft. Im Jahr 2026 bedeutet Online-Auffindbarkeit mehr als nur Google-Rankings—es bedeutet, von KI-gestützten Answer Engines und generativen Suchsystemen gefunden zu werden.',
      },
    ],
    content: [
      {
        type: 'h2',
        text: 'What it does',
      },
      {
        type: 'ul',
        items: [
          'Analyzes your website for SEO (Search Engine Optimization) best practices',
          'Evaluates AEO (Answer Engine Optimization) readiness for AI assistants',
          'Checks GEO (Generative Engine Optimization) compatibility for LLM-based search',
          'Provides a clear visibility score with prioritized recommendations',
          'Sends you a detailed PDF report with actionable insights',
          'Generates a tailored improvement prompt for your AI Website Builder',
        ],
      },
      {
        type: 'embed',
        component: 'ProjectToolEmbed',
      },
    ],
    contentDe: [
      {
        type: 'h2',
        text: 'Was es macht',
      },
      {
        type: 'ul',
        items: [
          'Analysiert deine Website auf SEO (Suchmaschinenoptimierung) Best Practices',
          'Bewertet die AEO (Answer Engine Optimization) Bereitschaft für KI-Assistenten',
          'Prüft die GEO (Generative Engine Optimization) Kompatibilität für LLM-basierte Suche',
          'Liefert einen klaren Sichtbarkeits-Score mit priorisierten Empfehlungen',
          'Erstellt einen herunterladbaren PDF-Report mit umsetzbaren Insights',
        ],
      },
      {
        type: 'embed',
        component: 'ProjectToolEmbed',
      },
    ],
    sources: [
      {
        label: 'Google Search Central - SEO Starter Guide',
        url: 'https://developers.google.com/search/docs/fundamentals/seo-starter-guide',
      },
      {
        label: 'Answer Engine Optimization Research',
        url: 'https://www.semrush.com/blog/answer-engine-optimization/',
      },
    ],
  },
  {
    id: 'project-x-alpha',
    slug: 'project-x-alpha',
    title: 'Top Secret Project',
    titleDe: 'Top Secret Project',
    date: '2026-03-15',
    author: 'Stefan Artmann',
    summary: 'Something extraordinary is in development. We\'re working on an innovative solution that will be revealed soon. Stay tuned for more content and details about this exciting project.',
    summaryDe: 'Etwas Außergewöhnliches ist in Entwicklung. Wir arbeiten an einer innovativen Lösung, die bald enthüllt wird. Bleiben Sie dran für mehr Inhalte und Details zu diesem spannenden Projekt.',
    coverImage: '/assets/images/top-secret-project-coming-soon-1770432875066.jpg',
    tags: ['Coming Soon', 'Innovation', 'Top Secret'],
    tagsDe: ['Demnächst', 'Innovation', 'Streng Geheim'],
    category: 'Experiment',
    categoryDe: 'Experiment',
    ctaLabel: 'Still Classified',
    ctaLabelDe: 'Still Classified',
    intro: [
      {
        type: 'p',
        text: 'This project is currently under development. More content and details will be available soon. We\'re excited to share this innovation with you in the near future.',
      },
    ],
    introDe: [
      {
        type: 'p',
        text: 'Dieses Projekt befindet sich derzeit in der Entwicklung. Mehr Inhalte und Details werden bald verfügbar sein. Wir freuen uns darauf, diese Innovation in naher Zukunft mit Ihnen zu teilen.',
      },
    ],
    content: [
      {
        type: 'h2',
        text: 'Coming Soon',
      },
      {
        type: 'p',
        text: 'More information will be revealed shortly. Check back soon for updates.',
      },
    ],
    contentDe: [
      {
        type: 'h2',
        text: 'Demnächst',
      },
      {
        type: 'p',
        text: 'Weitere Informationen werden in Kürze bekannt gegeben. Schauen Sie bald wieder vorbei für Updates.',
      },
    ],
    sources: [],
  },
  {
    id: 'project-nexus',
    slug: 'project-nexus',
    title: 'Top Secret Project',
    titleDe: 'Top Secret Project',
    date: '2026-04-20',
    author: 'Stefan Artmann',
    summary: 'Something extraordinary is in development. We\'re working on an innovative solution that will be revealed soon. Stay tuned for more content and details about this exciting project.',
    summaryDe: 'Etwas Außergewöhnliches ist in Entwicklung. Wir arbeiten an einer innovativen Lösung, die bald enthüllt wird. Bleiben Sie dran für mehr Inhalte und Details zu diesem spannenden Projekt.',
    coverImage: '/assets/images/top-secret-project-coming-soon-1770432875066.jpg',
    tags: ['Coming Soon', 'Innovation', 'Top Secret'],
    tagsDe: ['Demnächst', 'Innovation', 'Streng Geheim'],
    category: 'Case Study',
    categoryDe: 'Fallstudie',
    ctaLabel: 'Still Classified',
    ctaLabelDe: 'Still Classified',
    intro: [
      {
        type: 'p',
        text: 'This project is currently under development. More content and details will be available soon. We\'re excited to share this innovation with you in the near future.',
      },
    ],
    introDe: [
      {
        type: 'p',
        text: 'Dieses Projekt befindet sich derzeit in der Entwicklung. Mehr Inhalte und Details werden bald verfügbar sein. Wir freuen uns darauf, diese Innovation in naher Zukunft mit Ihnen zu teilen.',
      },
    ],
    content: [
      {
        type: 'h2',
        text: 'Coming Soon',
      },
      {
        type: 'p',
        text: 'More information will be revealed shortly. Check back soon for updates.',
      },
    ],
    contentDe: [
      {
        type: 'h2',
        text: 'Demnächst',
      },
      {
        type: 'p',
        text: 'Weitere Informationen werden in Kürze bekannt gegeben. Schauen Sie bald wieder vorbei für Updates.',
      },
    ],
    sources: [],
  },
  {
    id: 'top-secret-apps',
    slug: 'top-secret-apps',
    title: 'Top Secret Project',
    titleDe: 'Top Secret Project',
    date: '2026-05-15',
    author: 'Stefan Artmann',
    summary: 'Something extraordinary is in development. We\'re working on an innovative solution that will be revealed soon. Stay tuned for more content and details about this exciting project.',
    summaryDe: 'Etwas Außergewöhnliches ist in Entwicklung. Wir arbeiten an einer innovativen Lösung, die bald enthüllt wird. Bleiben Sie dran für mehr Inhalte und Details zu diesem spannenden Projekt.',
    coverImage: '/assets/images/top-secret-project-coming-soon-1770432875066.jpg',
    tags: ['Coming Soon', 'Innovation', 'Top Secret'],
    tagsDe: ['Demnächst', 'Innovation', 'Streng Geheim'],
    category: 'Apps',
    categoryDe: 'Apps',
    ctaLabel: 'Still Classified',
    ctaLabelDe: 'Still Classified',
    intro: [
      {
        type: 'p',
        text: 'This project is currently under development. More content and details will be available soon. We\'re excited to share this innovation with you in the near future.',
      },
    ],
    introDe: [
      {
        type: 'p',
        text: 'Dieses Projekt befindet sich derzeit in der Entwicklung. Mehr Inhalte und Details werden bald verfügbar sein. Wir freuen uns darauf, diese Innovation in naher Zukunft mit Ihnen zu teilen.',
      },
    ],
    content: [
      {
        type: 'h2',
        text: 'Coming Soon',
      },
      {
        type: 'p',
        text: 'More information will be revealed shortly. Check back soon for updates.',
      },
    ],
    contentDe: [
      {
        type: 'h2',
        text: 'Demnächst',
      },
      {
        type: 'p',
        text: 'Weitere Informationen werden in Kürze bekannt gegeben. Schauen Sie bald wieder vorbei für Updates.',
      },
    ],
    sources: [],
  },
  {
    id: 'top-secret-games',
    slug: 'top-secret-games',
    title: 'Top Secret Project',
    titleDe: 'Top Secret Project',
    date: '2026-06-15',
    author: 'Stefan Artmann',
    summary: 'Something extraordinary is in development. We\'re working on an innovative solution that will be revealed soon. Stay tuned for more content and details about this exciting project.',
    summaryDe: 'Etwas Außergewöhnliches ist in Entwicklung. Wir arbeiten an einer innovativen Lösung, die bald enthüllt wird. Bleiben Sie dran für mehr Inhalte und Details zu diesem spannenden Projekt.',
    coverImage: '/assets/images/top-secret-project-coming-soon-1770432875066.jpg',
    tags: ['Coming Soon', 'Innovation', 'Top Secret'],
    tagsDe: ['Demnächst', 'Innovation', 'Streng Geheim'],
    category: 'Games',
    categoryDe: 'Games',
    ctaLabel: 'Still Classified',
    ctaLabelDe: 'Still Classified',
    intro: [
      {
        type: 'p',
        text: 'This project is currently under development. More content and details will be available soon. We\'re excited to share this innovation with you in the near future.',
      },
    ],
    introDe: [
      {
        type: 'p',
        text: 'Dieses Projekt befindet sich derzeit in der Entwicklung. Mehr Inhalte und Details werden bald verfügbar sein. Wir freuen uns darauf, diese Innovation in naher Zukunft mit Ihnen zu teilen.',
      },
    ],
    content: [
      {
        type: 'h2',
        text: 'Coming Soon',
      },
      {
        type: 'p',
        text: 'More information will be revealed shortly. Check back soon for updates.',
      },
    ],
    contentDe: [
      {
        type: 'h2',
        text: 'Demnächst',
      },
      {
        type: 'p',
        text: 'Weitere Informationen werden in Kürze bekannt gegeben. Schauen Sie bald wieder vorbei für Updates.',
      },
    ],
    sources: [],
  },
  {
    id: 'top-secret-content',
    slug: 'top-secret-content',
    title: 'Top Secret Project',
    titleDe: 'Top Secret Project',
    date: '2026-07-15',
    author: 'Stefan Artmann',
    summary: 'Something extraordinary is in development. We\'re working on an innovative solution that will be revealed soon. Stay tuned for more content and details about this exciting project.',
    summaryDe: 'Etwas Außergewöhnliches ist in Entwicklung. Wir arbeiten an einer innovativen Lösung, die bald enthüllt wird. Bleiben Sie dran für mehr Inhalte und Details zu diesem spannenden Projekt.',
    coverImage: '/assets/images/top-secret-project-coming-soon-1770432875066.jpg',
    tags: ['Coming Soon', 'Innovation', 'Top Secret'],
    tagsDe: ['Demnächst', 'Innovation', 'Streng Geheim'],
    category: 'Content',
    categoryDe: 'Content',
    ctaLabel: 'Still Classified',
    ctaLabelDe: 'Still Classified',
    intro: [
      {
        type: 'p',
        text: 'This project is currently under development. More content and details will be available soon. We\'re excited to share this innovation with you in the near future.',
      },
    ],
    introDe: [
      {
        type: 'p',
        text: 'Dieses Projekt befindet sich derzeit in der Entwicklung. Mehr Inhalte und Details werden bald verfügbar sein. Wir freuen uns darauf, diese Innovation in naher Zukunft mit Ihnen zu teilen.',
      },
    ],
    content: [
      {
        type: 'h2',
        text: 'Coming Soon',
      },
      {
        type: 'p',
        text: 'More information will be revealed shortly. Check back soon for updates.',
      },
    ],
    contentDe: [
      {
        type: 'h2',
        text: 'Demnächst',
      },
      {
        type: 'p',
        text: 'Weitere Informationen werden in Kürze bekannt gegeben. Schauen Sie bald wieder vorbei für Updates.',
      },
    ],
    sources: [],
  },
];